import { render, staticRenderFns } from "./SeaTourRoutes.vue?vue&type=template&id=c67646e4&scoped=true&"
import script from "./SeaTourRoutes.vue?vue&type=script&lang=js&"
export * from "./SeaTourRoutes.vue?vue&type=script&lang=js&"
import style0 from "./SeaTourRoutes.vue?vue&type=style&index=0&id=c67646e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67646e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c67646e4')) {
      api.createRecord('c67646e4', component.options)
    } else {
      api.reload('c67646e4', component.options)
    }
    module.hot.accept("./SeaTourRoutes.vue?vue&type=template&id=c67646e4&scoped=true&", function () {
      api.rerender('c67646e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/seatour/SeaTourRoutes.vue"
export default component.exports